<template lang="html">
  <b-container id="view-shipping">
    <admin-shipping ref="theShipping" v-show="selectedSearchItem" @shippingupdated="reloadShipping"></admin-shipping>
  </b-container>
</template>

<script>
import AdminShipping from '@/components/AdminShipping'

export default {
  components: {
    AdminShipping
  },
  data() {
    return {
      selectedSearchItem: null
    }
  },
  beforeRouteUpdate(to, from, next) {
    next()
    this.getShipping()
  },
  mounted() {
    this.getShipping()
  },
  methods: {
    getShipping() {
      let params = {
        includes: [
          'status_history',
          'user',
          'company',
          'courier.courier_available.tracking',
          'budget.quote',
          'tags',
          'threads.messages.sender',
          'previousShipping',
          'followingShippings',
          'items',
          'deliveryTimeRange',
          'courier_company',
          'last_known_place',
          'checkpoints.place',
          'checkpoints.user',
          'checkpoints.warehouse'
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'shippings/' + this.$route.params.id, {params: params})
        .then(response => {
          this.selectedSearchItem = response.body
          console.log(response.data.status_history)
          let shipping = response.data

          if (shipping.status_history.findIndex(x => x.status === 'DRAFT') === -1) {
            shipping.status_history.push(
              {
                created_at: this.moment(shipping.created_at).format('YYYY-MM-DD HH:mm:ss'),
                details: null,
                meta: null,
                shipping_id: shipping.id,
                status: 'DRAFT'
              }
            )
          }

          this.$refs.theShipping.shipping = shipping
          this.$refs.theShipping.allowResetCourier = true
          this.$refs.theShipping.courier = response.body.courier
        })
    },
    reloadShipping() {
      this.getShipping()
    }
  }
}
</script>
